<template>
    <footer id="colophon" class="site-footer" >
		<div class="inner">
			
            <div id="legalfoot" class="bottomflex">
                <div class="flexbig">
                    <p>Copyright © 2021, Your Live Streaming. All rights reserved.</p>
                </div>
            </div>
		</div>
	</footer>
</template>


<script>
export default {
  data: () => {
      return {

      }
  },
}
</script>

<style scoped>
#legalfoot {
    border-top: none;
    padding-top: 0;
}
footer {
    transition: all 0.5s ease-in;
}
.fixedFooter {
    position: fixed;
    bottom: 0;
    
}
.flexbig p {
    text-align: center;
}
</style>